import functions from '../functions';

let id = 0;
const instance = {};
// resolved lazily, NOT cached at module load: with the dynamic-package tab the
// #details-datepicker markup is injected over ajax after this module evaluates,
// so caching it here would leave it empty and the details-page branch dead.
let $details = $('#details-datepicker');
let details = $details[0];

class DeparturePicker {
    constructor(elem) {
        this.id = ++id;
        instance[this.id] = this;
        this.params = {};

        // re-resolve in case #details-datepicker was injected after page load
        if (!details) {
            $details = $('#details-datepicker');
            details = $details[0];
        }
        this.$departurePoint = null;

        this.gettingDepartures = false;

        this.$elem = $(elem);

        this.$elem._flatpickr = flatpickr(elem, {
            altInput: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            closeOnSelect: false,
            disableMobile: true,
            onOpen: (selected, dateStr, instance) => {
                instance.set('minDate', this.firstDate);
                if(dateStr) {
                    this.setDurationPicker(this.departures, selected, dateStr, instance);
                }
            },
            onClose: (selected, dateStr, instance) => {
                instance.setDate(dateStr);
                this.$elem.parents('form').trigger('change');
            },
            onChange: (selected, dateStr, instance) => {
                if(dateStr === '') {
                    const $form = $(instance.element).parents('.search-form');
                    $form.find('[name="dateTo"]').val('');
                    $form.find('[name="arrivalDateFrom"]').val('');
                    $form.find('[name="arrivalDateTo"]').val('');
                    $form.find('[name="aDateFrom"]').val('');
                    $form.find('[name="aDateTo"]').val('');
                }
                this.setDurationPicker(this.departures, selected, dateStr, instance);
            },
            onReady: (dateObj, dateStr, instance) => {
                const $container = $(instance.calendarContainer);
                $container.append(this.printDurationPickerContainer());

                $(instance.element).change(e => {
                    if(e.originalEvent) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            },
        });
        
        if(details) {
            this.$elem._flatpickr.set('clickOpens', true);
        } else {
            this.$elem._flatpickr.set('clickOpens', false);
        }

        ! $('[name="destination"]')[0] && this.setDepartures();

        this.getParams();

        this.$departurePoint = this.$elem.closest('form').find("[name='placeFromId']");

        if (this.$elem.parents('[data-dynamicpackage]').length) {
            this.params.dynamicPackage = this.$elem.parents('[data-dynamicpackage]').attr('data-dynamicpackage');
        }

        $('[name="dateTo"]').val(this.params.dateTo);

        $('.datepicker [data-clear]').on('click', e => {
            this.$elem._flatpickr.clear();
            this.$elem._flatpickr.set('minDate', this.firstDate);
        });

        $(this.$elem._flatpickr.altInput).on('click', e => {

            const $searchForm = this.$elem.parents('.search-form');
            const $formGuide = $searchForm.find('.form-guide');
            const formGuide = $formGuide[0];

            if (details || $searchForm.find('[name="destination"]').val()) {
                this.$elem._flatpickr.set('clickOpens', true);
            } else {
                this.$elem._flatpickr.set('clickOpens', false);
            }

            if(formGuide && ! this.$elem._flatpickr.config.clickOpens) {
                setTimeout(() => {
                    formGuide._formGuide.show();
                });
            }

        });

        ! details && this.$departurePoint.on('change', e => {
            const $target = $(e.currentTarget);
            const $searchForm = this.$elem.parents('.search-form');

            setTimeout(() => {
                const hasdestination = $searchForm.find('[name="destination"]').val() && $searchForm.find('[name="destination"]').val() !== '';
                this.isFormElem($target) && ! this.gettingDepartures && hasdestination && this.setDepartures();
            });
        });

        $('[name="destination"]').on('change', e => {
            const $target = $(e.currentTarget);
            this.params.destination = $target.val();
            setTimeout(() => {
                this.isFormElem($target) && this.params.destination && ! this.gettingDepartures && this.setDepartures();
            });
        });

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            const isFormElem = this.isFormElem($(e.currentTarget));
            isFormElem && this.$elem._flatpickr.clear();
            isFormElem && this.$elem._flatpickr.set('clickOpens', false);
        });
        
        $(window).on('hashchange', e => {
            //this.setDepartures();
        });
    }

    isFormElem($target) {
        this.$form = $target.parents('.search-form');
        return this.$form.has(this.$elem).length;
    }

    printDurationPickerContainer() {
        return `
            <div class="duration-picker text-start border-top border-primary px-3 py-2">
                <div class="fw-bold text-uppercase mb-1">Trajanje putovanja</div>
                <div class="choose-label text-danger">Izaberite datum sa kalendara</div>
                <div class="row d-none"></div>
            </div>
        `;
    }

    printDurationItem(departure, index) {
        return `
            <div class="col-auto">
                <button class="duration-item btn btn-sm btn-outline-primary fw-bold mb-1"
                    data-dateFrom="${ departure.dateFrom }"
                    data-dateTo="${ departure.dateTo }"
                    data-adateFrom="${ departure.aDateFrom }"
                    data-adateTo="${ departure.aDateTo }"
                    data-time="${ departure.time }"
                    data-duration="${ departure.duration }"
                    data-nights="${ departure.nights }"
                    data-index="${ index }">
                    ${ departure.nights } noći | Povratak: ${ functions.formatDate(departure.dateTo) }
                </button>
            </div>
        `;
    }

    getParams() {
        //this.params = functions.getUrlData(true);
        this.params = $.extend({}, this.params, functions.getUrlData(true));
    }

    setDepartures() {
        ! this.params.destination && this.getParams();

        if(details) {
            this.params.destination = $details.attr('data-countryid');
        }

        let params = this.params;
        params.countryId = params.destination && params.destination.split(':')[0];
        params.regionId = params.destination && params.destination.split(':')[1] ? params.destination.split(':')[1] : null;
        params.placeId = params.destination && params.destination.split(':')[3] ? params.destination.split(':')[3] : null;

        if (! details && this.gettingDepartures) return;
        this.gettingDepartures = true;

        setTimeout(() => {
            if (this.$departurePoint && this.$departurePoint.length) {
                let depPoints = this.$elem.closest('form').find("[name='placeFromId']")[0].departure;
    
                if (params.dynamicPackage == "1") {
                    depPoints ? (params.flightUnitIds = depPoints.data ? depPoints.data.flightUnitIds : null) : (params.flightUnitIds = null);
                } else {
                    depPoints ? (params.transportUnitIds = depPoints.data ? depPoints.transportUnitIds : null) : (params.transportUnitIds = null);
                }
            }
    
            const getDepartures = this.getDepartures(params);
            
            if(getDepartures) {
                getDepartures.done(response => {
                    
                    this.departures = response;
                    let departures = {};
                    Object.keys(this.departures).forEach(index => {
                        let rate = this.departures[index];
    
                        let unique = rate.dateFrom + ',' + rate.dateTo + ', ' + rate.nights;
    
                        if ( ! departures[unique]) {
                            departures[unique] = this.departures[index];
                        }
                    });
                    this.departures = Object.values(departures);
    
                    this.departures.sort((a, b) => {
                        return new Date(a.dateFrom).getTime() - new Date(b.dateFrom).getTime() || a.nights - b.nights;
                    });
    
                    this.$elem._flatpickr.set('enable', this.getEnableDates(this.departures));
                    this.$elem._flatpickr.set('clickOpens', true);
    
                    this.firstDate = this.getEnableDates(this.departures)[0] ? this.getEnableDates(this.departures)[0] : null;
                    this.$elem._flatpickr.set('minDate', this.firstDate);
    
                }).fail(error => {
                    console.log(error);
                });
            } else if(details && $details.attr('data-departures')) {
                this.departures = JSON.parse($details.attr('data-departures'));
    
                this.departures.sort((a, b) => {
                    return new Date(a.dateFrom).getTime() - new Date(b.dateFrom).getTime() || a.duration - b.duration;
                });
    
                this.$elem._flatpickr.set('enable', this.getEnableDates(this.departures));
                this.$elem._flatpickr.set('clickOpens', true);
            } else {
                this.$elem._flatpickr.set('clickOpens', false);
            }

            this.gettingDepartures = false;
        }, 600);

    }

    getDepartures(params) {
        if(params.countryId) {
            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/get_departures/'
                + '?dynamicPackage=' + params.dynamicPackage
                + '&countryId=' + params.countryId
                + (params.placeId ? '&placeId=' + params.placeId : '')
                + (params.regionId ? '&regionId=' + params.regionId : '')
                + (params.flightUnitIds ? '&flightUnitIds=' + params.flightUnitIds : '')
                + (params.transportUnitIds ? '&transportUnitIds=' + params.transportUnitIds : '')
            );
        }
        return null;
    }

    getEnableDates(departures) {
        let enable = [];
        if(departures) {
            Object.entries(departures).forEach(item => {
                const departure = item[1];
                enable.push(departure.dateFrom);
            });
            enable = enable.filter((item, index, array) => {
                return array.indexOf(item) === index;
            });
        }
        return enable;
    }

    setDurationPicker(departures, selected, dateStr, instance) {
        const $container = $(instance.calendarContainer);
        const $durationPicker = $container.find('.duration-picker');
        const $row = $durationPicker.find('.row');
        const $chooseLabel = $durationPicker.find('.choose-label');

        $durationPicker.find('.col-auto').remove();

        if(departures && departures.length) {

            $row.removeClass('d-none');
            $chooseLabel.addClass('d-none');

            let index = 0;

            departures.forEach(departure => {
                if(departure.dateFrom == dateStr) {
                    $row.append(this.printDurationItem(departure, index));

                    let $durationItem = null;

                    $('.duration-item').removeClass('active');
                    if(this.params.dateTo && this.params.time && $('.duration-item[data-dateTo="' + this.params.dateTo + '"][data-time="' + this.params.time + '"]')[0]) {
                        $durationItem = $('.duration-item[data-dateTo="' + this.params.dateTo + '"][data-time="' + this.params.time + '"]');
                        $durationItem.addClass('active');

                        this.params.aDateFrom = $durationItem.attr('data-adatefrom');
                        this.params.aDateTo = $durationItem.attr('data-adateto');

                        $('[name="dateTo"]').val(this.params.dateTo);
                        $('[name="aDateFrom"]').val(this.params.aDateFrom);
                        $('[name="aDateTo"]').val(this.params.aDateTo);

                    } else if(this.params.dateTo && $('.duration-item[data-dateTo="' + this.params.dateTo + '"]')[0]) {
                        $durationItem = $('.duration-item[data-dateTo="' + this.params.dateTo + '"]').first();
                        $durationItem.addClass('active');

                        this.params.aDateFrom = $durationItem.attr('data-adatefrom');
                        this.params.aDateTo = $durationItem.attr('data-adateto');

                        $('[name="dateTo"]').val(this.params.dateTo);
                        $('[name="aDateFrom"]').val(this.params.aDateFrom);
                        $('[name="aDateTo"]').val(this.params.aDateTo);
                        
                    } else {
                        $durationItem = $('.duration-item[data-index="0"]');
                        $durationItem.addClass('active');

                        this.params.aDateFrom = $durationItem.attr('data-adatefrom');
                        this.params.aDateTo = $durationItem.attr('data-adateto');

                        $('[name="aDateFrom"]').val(this.params.aDateFrom);
                        $('[name="aDateTo"]').val(this.params.aDateTo);

                        index == 0 && $('[name="dateTo"]').val(departure.dateTo) && $('[name="duration"]').val($durationItem.attr('data-duration'));
                    }

                    index++;
                }
            });

            $('.duration-item').on('click', e => {
                e.preventDefault();
                e.stopPropagation();
                $('.duration-item').removeClass('active');
                const $target = $(e.currentTarget);
                let dateTo = $target.attr('data-dateTo');
                let aDateFrom = $target.attr('data-adatefrom');
                let aDateTo = $target.attr('data-adateto');
                let time = $target.attr('data-time');
                let duration = $target.attr('data-duration');

                $target.addClass('active');
                this.params.dateTo = dateTo;
                this.params.time = time;

                $('[name="dateTo"]').val(dateTo);
                $('[name="time"]').val(time);
                $('[name="aDateTo"]').val(aDateTo);
                $('[name="aDateFrom"]').val(aDateFrom);
                $('[name="duration"]').val(duration);

                $('[name="dateTo"]').trigger('change');
 
                instance.close();
            });

            $('[name="dateTo"]').on('change', e => {
                const $target = $(e.currentTarget);
                $('.duration-item[data-dateTo="' + $target.val() + '"][data-time="' + $('[name="time"]').val() + '"]').addClass('active');
            });
        }

    }
}

export {
	DeparturePicker
};